module.exports = __webpack_public_path__ + "core-img/datepicker-nav.06cff024e5343ff7bb05a38ca13e90f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/datepicker-nav.png
// module id = 113
// module chunks = 0